import { Timestamp } from '@firebase/firestore-types';

export enum OrderType {
  REGULAR_ORDERS = 'regular_order',
  REGULAR_PRE_ORDERS = 'regular_pre_order',
  SPECIAL_ORDERS = 'special_order',
  SPECIAL_PRE_ORDERS = 'special_pre_order',
}

export interface IMultiOrder {
  restaurant_id: string;
  status: string;
  rider_id: string;
}
export interface IOrders {
  id: string;
  payment_method: string;
  bill_status: string;
  customer_info: ICustomerInfo;
  order_create_time: Timestamp;
  order_table_number: string;
  order_username: string;
  order_status: string;
  restaurant_id: string;
  rider_id: string;
  foods: IFood[];
  promotion_foods?: IFood[];
  food_order_status?: string;
  food_promotion_order_status?: string;
  type: string;
  seat_type?: string;
  seat_number?: string;
  has_damaged_order?: boolean;
  is_damaged?: boolean;
  parent_id?: string;
  damaged_number?: number;
  order_type: OrderType;
  is_pre_order: boolean;
  requested_delivery_time?: Timestamp;
  delivery_request?: string;
  multi_orders?: IMultiOrder[];
  restaurant_ids?: string[];
  completed_time?: Timestamp;
  email_or_phone?: string;
  email?: string;
  phone?: string;
  gift_info?: IGiftInfo;
  stadium_id?: string;
  rider_info?: { name: string; image?: string };
  all_foods?: IFood[];
}

export interface IGiftInfo {
  delivery_date?: string;
  receiver_name?: string;
  receiver_email?: string;
  receiver_phone?: string;
}

export interface IFood {
  created: string;
  item_deleted_quantity?: number;
  item_customize_settings: ITopic[];
  item_food_id: string;
  item_name: string;
  item_note: string;
  item_price: number;
  item_quantity: number;
  item_subtotal: number;
  status: string;
  tax_rate: string;
  sku: string;
  restaurantId: string;
}

export interface ITopic {
  name: string;
  price: number;
}

export interface ICustomerInfo {
  number_of_adult: number;
  number_of_child: number;
}
